import { SVGProps } from "react";

export default function OvalIcon(props: SVGProps<any>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height={282}
      fill="none"
      {...props}
    >
      <g filter="url(#filter0_f_5067_244780)">
        <ellipse
          cx={216.5}
          cy={183.5}
          fill={props.fill}
          fillOpacity={0.03}
          rx={215.5}
          ry={132.5}
        />
      </g>
      <defs>
        <filter
          id="filter0_f_5067_244780"
          width={533}
          height={367}
          x={-50}
          y={0}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feBlend in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feGaussianBlur
            result="effect1_foregroundBlur_5067_244780"
            stdDeviation={25.5}
          />
        </filter>
      </defs>
    </svg>
  );
}
